import { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import CustomButton from "../../../common/CustomButton"
import useMilestones from "../../../hooks/useMilestones";
import Milestone from "./Milestone";

import useCountDown from "../../../hooks/useCountDown";
import useSVG from "../../../hooks/useSVG";
import useAccomplishments from "../../../hooks/useAccomplishments";

import { GetChallengeHistory } from "../../../redux/v2/challenge/actions";
import Badge from "./Badge";


function ChallengeCard(props) {
    const { myChallenges, histories } = props.Challenge;

    const { challenge, onSelect, status } = props;
    const { accomplishment } = useAccomplishments({ challenge, histories });
    const { current } = useMilestones({ challenge: challenge, accomplishment: accomplishment });
    const { days, remaining } = useCountDown({ challenge: challenge });
    const { UseChalengesSVG } = useSVG();

    let isAccepted = false;

    myChallenges?.map((mc) => {
        if (mc.challengeID == challenge.id) {
            isAccepted = true;
        }
    })

    useEffect(() => {
        props.GetChallengeHistory(challenge);
    }, [challenge])

    const baseurl = (process.env.REACT_APP_ENVIRONMENT == "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV);
    const gradient = challenge?.gradient.split("-");

    return (
        <Link to={`/challenges?challenge=${challenge.id}`}>
            <div id="challenge-card" onClick={onSelect} className={challenge?.company ? "cc-company" : ""} style={challenge?.gradient ? { backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` } : null}>

                <div id="cc-info-wrapper">
                    <div className="head-badge-wrapper">
                        <div className="head-badge">
                            {
                                challenge?.company
                                    ? <Badge isComplete={true} logo={challenge?.badge ? (baseurl + challenge?.badge) : null} />
                                    : (challenge?.svg ? UseChalengesSVG(challenge?.svg) : "")
                            }
                        </div>
                    </div>
                    <h4>{challenge?.title}</h4>
                    <p>{challenge?.description}</p>
                    {
                        (!isAccepted && !challenge?.company) && <CustomButton onClick={onSelect}>VIEW CHALLENGE</CustomButton>
                    }
                </div>

                {
                    challenge.status != 2 &&
                    <div className="p-days">
                        {
                            isAccepted &&
                            <div id="cc-milestone-wrapper">
                                <Milestone
                                    type={challenge?.unit}
                                    value={current?.value}
                                    max={current?.max}
                                    min={current?.min}
                                    stage={current?.stage}
                                    challenge={challenge}
                                    upcoming={status == "upcoming" ? {
                                        header: "JOINED!",
                                        subtext: (
                                            <>This challenge begins on <span className="orange t-bold">{moment(new Date(challenge.startdate)).calendar()}</span></>
                                        )
                                    } : null}
                                />
                            </div>
                        }

                        <p>{remaining != 0 && days}</p>
                    </div>
                }

            </div>
        </Link>
    );
}

const mapStateToProps = (state) => ({
    Challenge: state.Challenge,
    User: state.User,
});

export default connect(mapStateToProps, {
    GetChallengeHistory,
})(ChallengeCard);